import { ITrackResult } from '@/helpers/getNowPlaying';
import { defaultRadioArtwork } from '@/store/PlayerStore';
import useSWR from 'swr';
import { fetcher } from '@/helpers/apiHelpers';

export const useNowPlaying = () => {
  const { data, mutate } = useSWR(process.env.NEXT_PUBLIC_NOW_PLAYING_URL, fetcher);

  const nowPlayingData: ITrackResult = {
    title: data?.title ||'On air',
    artist: data?.artist || 'newonce.radio',
    artworkUrl: data?.artworkUrl || defaultRadioArtwork,
    artworkUrlLarge: data?.artworkUrlLarge || defaultRadioArtwork
  }

  return {
    nowPlayingData,
    mutate
  }
}
